import React, {useMemo} from 'react';
import {Redirect, useRouteMatch} from "react-router";
import {usePriceList} from "../../Providers/PriceListProvider";
import {useShoppingCart} from "../hooks/shoppingcart";
import EditProduct from "./EditProduct/EditProduct";
import ShoppingCartEditTemplateProduct from "../Components/ShoppingCartEditTemplateProduct";


export default () => {
    const match = useRouteMatch();
    const {items, loading} = useShoppingCart ();

    const orderLine = useMemo(() => {
        return items.find(item => item.uuid == match.params.uuid);
    }, [items, match]);

    if (loading) {
        return <div>Loading</div>
    }

    if (!orderLine) {
        console.log('No order line, redirecting', items, match.params);
        return <Redirect to={'/cart'} />
    }

    switch (orderLine.product.type) {
        case 0:
            return <EditProduct />
        case 1:
        case 2:
        case 89:
            return <ShoppingCartEditTemplateProduct
                orderLine={orderLine}
            />
    }
    return <div>Loading</div>;
}